import axiosPost from '../axiosPost';

export const formatosXTipoDeImagenUpd = async (arg) => {
    const { id, nombre, codigo, ancho, alto, bucket, folder, version } = arg;

    const body = {
        "service": "FormatoXTipoDeImagenUpd",
        "params": {
            "formatoXTipoDeImagenId": id,
            "formatoXTipoDeImagenNombre": nombre,
            "formatoXTipoDeImagenCod": codigo,
            "formatoXTipoDeImagenAncho": ancho,
            "formatoXTipoDeImagenAlto": alto,
            "formatoXTipoDeImagenBucket": bucket,
            "formatoXTipoDeImagenFolder": folder,
            "formatoXTipoDeImagenVersion": version,
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}